var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 3.61719,
    width: 14.5,
    height: 2.90951,
    fill: "#C4C4C4",
    fillOpacity: 0.3,
    stroke: "#828282",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 6.97656,
    width: 14.5,
    height: 2.90951,
    fill: "#C4C4C4",
    fillOpacity: 0.3,
    stroke: "#828282",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 10.3438,
    width: 14.5,
    height: 2.90951,
    fill: "#C4C4C4",
    fillOpacity: 0.3,
    stroke: "#828282",
    strokeWidth: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 2.90951,
    fill: "#20639B",
    fillOpacity: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 2.90951,
    fill: "url(#paint0_linear_14851_4047)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 14.5,
    height: 2.90951,
    stroke: "#828282",
    strokeWidth: 0.5
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 13.7031,
    width: 14.5,
    height: 2.90951,
    fill: "#C4C4C4",
    fillOpacity: 0.3,
    stroke: "#828282",
    strokeWidth: 0.5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.3125,
    y: 3.625,
    width: 2.55973,
    height: 12.9923,
    stroke: "#828282",
    strokeWidth: 0.5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 9.42969,
    y: 3.625,
    width: 2.55973,
    height: 12.9923,
    stroke: "#828282",
    strokeWidth: 0.5
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.73438,
    y: 7.375,
    width: 1.78351,
    height: 2.06856,
    stroke: "#EB5757"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14851_4047",
    x1: 7.5,
    y1: 0,
    x2: 7.5,
    y2: 3.40951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectDate);
export default __webpack_public_path__ + "static/media/select-date.037fd4d76f116f8d2a636956c1e420b7.svg";
export { ForwardRef as ReactComponent };